(() => {
  if (customElements.get('joffz-shop-the-look')) return;

  customElements.define('joffz-shop-the-look', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.canvas = this.querySelector('[data-look-canvas]');
      this.modalIds = new Set(Array.from(this.querySelectorAll('modal-opener[data-modal]'), opener => opener.dataset.modal.slice(1)));
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest('[data-look-trigger]');
        if (trigger) {
          const hotspot = trigger.closest('[data-look-hotspot]');
          if (hotspot === this.active) this.close(false);
          else this.open(hotspot);
        } else if (event.target.closest('[data-look-close]')) this.close(true);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.active) return;
        event.preventDefault();
        event.stopPropagation();
        this.close(true);
      }, options);
      const closeOutside = event => {
        if (this.active && !this.active.contains(event.target) && !this.inOwnedModal(event.target)) this.close(false);
      };
      document.addEventListener('pointerdown', closeOutside, options);
      document.addEventListener('focusin', closeOutside, options);
      window.addEventListener('resize', () => this.position(), options);
      this.canvas?.querySelector('img')?.addEventListener('load', () => this.position(), options);
      this.addEventListener('shopify:block:select', event => {
        const hotspot = event.target.closest('[data-look-hotspot]');
        if (hotspot) this.open(hotspot);
      }, options);
      this.addEventListener('shopify:block:deselect', () => this.close(false), options);
    }

    inOwnedModal(target) {
      return target instanceof Element && this.modalIds.has(target.closest('quick-add-modal')?.id);
    }

    open(hotspot) {
      if (!hotspot) return;
      this.close(false);
      this.active = hotspot;
      hotspot.setAttribute('data-open', '');
      hotspot.querySelector('[data-look-trigger]').setAttribute('aria-expanded', 'true');
      hotspot.querySelector('[data-look-panel]').hidden = false;
      this.position();
    }

    close(restoreFocus) {
      if (!this.active) return;
      const hotspot = this.active;
      this.active = null;
      hotspot.removeAttribute('data-open');
      const trigger = hotspot.querySelector('[data-look-trigger]');
      trigger.setAttribute('aria-expanded', 'false');
      hotspot.querySelector('[data-look-panel]').hidden = true;
      if (restoreFocus) trigger.focus({ preventScroll: true });
    }

    position() {
      if (!this.active || !this.canvas) return;
      const hotspot = this.active.getBoundingClientRect();
      const canvas = this.canvas.getBoundingClientRect();
      const panel = this.active.querySelector('[data-look-panel]');
      const popup = panel.getBoundingClientRect();
      const minLeft = Math.max(12, canvas.left + 12);
      const maxRight = Math.min(window.innerWidth - 12, canvas.right - 12);
      let left = hotspot.right + 12;
      if (left + popup.width > maxRight) left = hotspot.left - popup.width - 12;
      left = Math.max(minLeft, Math.min(left, maxRight - popup.width));
      const maxTop = Math.max(canvas.top + 12, canvas.bottom - popup.height - 12);
      const top = Math.max(canvas.top + 12, Math.min(hotspot.top + hotspot.height / 2 - popup.height / 2, maxTop));
      panel.style.setProperty('--popover-left', `${Math.round(left - hotspot.left)}px`);
      panel.style.setProperty('--popover-top', `${Math.round(top - hotspot.top)}px`);
    }

    disconnectedCallback() {
      this.close(false);
      this.abort?.abort();
      this.abort = null;
      this.modalIds?.forEach(id => {
        const modal = document.getElementById(id);
        if (!modal?.classList.contains('joffz-collection-quick-modal')) return;
        if (modal.hasAttribute('open')) modal.hide();
        modal.remove();
      });
    }
  });
})();
